import ItemBaseController from '../common/item.base.controller'
import AppConstants from '../../../config/app.constants';

class ItemCreateController extends ItemBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, ItemService, Modal, $translate, $stateParams, LocationService, ServiceOrderService, DateUtil) {

		super(Auth, $state, User, ItemService, Modal, $translate, $stateParams)
		this.LocationService = LocationService;
		this.ServiceOrderService = ServiceOrderService;
		this.ItemService = ItemService;
		this.user = User;
		this.DateUtil = DateUtil;
		this.hasACL = {};
		this.defaultModel = {
			itemTypeId: null,
			barcode: null,
			itemLabel: null,
			notes: null,
			loggedInUserId: this.User.getUser().id,
			selectedBranch: [],
			errorMessage: '',
			branchId: this.User.getUser().branchId,
			loading: false,
			reference: null,
			expirationDate: null
		}
		this.model = angular.copy(this.defaultModel);
		this.userBranches = [];
		this.itemTypes = [];
		this.itemTypeList = [];
	}

	$onInit() {
		// this.loadUserBranches();
		// this.loadItemTypesX();
		this.loadItemTypes();
		this.model.maxDate = {
			minDate: moment().add('1', 'day')
		}
	}

	reset() {
		this.userBranches.forEach((branch) => {
			branch.ticked = false;
		})
		this.model = angular.copy(this.defaultModel);
		this.clearErrors();
	}

	submit() {
		this.model.loading = true;
		this.Service.create({
			label: this.model.itemTypeId.Label,
			barcode: this.model.barcode,
			branchId: this.model.branchId,
			itemTypeId: this.model.itemTypeId.Value,
			notes: this.model.notes,
			reference: this.model.reference,
			expirationDate: this.model.expirationDate ? moment(this.model.expirationDate).format('YYYY-MM-DD') : null
		})
			.then(() => {
				this.askCreate();
			})
			.catch((err) => {
				err.data.errors.map((e) => {
					this.model.errorMessage += e.message + '<br/>'
				})
			})
			.finally(() => {
				this.model.loading = false;
			})
	}

	loadItemTypesX() {
		this.ItemService.getItemTypes()
		.then(res => {
			this.itemTypes = res.results;
		})
		.catch(err => {
			console.log(err)
		})
	}

	loadUserBranches() {
		this.ServiceOrderService.getUserBranchList(this.model.loggedInUserId)
			.then(res => {
				this.userBranches = res.results;
				this.userBranches.forEach((branch) => {
					if (branch.branchId == this.branchId) {
						branch.ticked = true;
					}
				})
			})
			.catch(err => {
				console.log(err)
			})
	}

	getSelectedBranches() {
		return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
	}

	loadItemTypes(searchKey, offset) {
		searchKey = searchKey || null;
	
		return this.ItemService.getItemTypes(null, searchKey, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.itemTypes = data.results;
					this.totalRecords = data.total;
					this.itemTypeList = this.dataMapping(data.results);
				} else {
					const records = this.dataMapping(data.results);
					this.itemTypeList = this.itemTypeList.concat(records);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}
	
	dataMapping(array) {
		return array.map((data) => {
			return {
				Key: data.id + ' | ' + data.label,
				Value: data.id,
				Label: data.label
			}
		});
	}

	validateForm() {
		return !(this.model.itemTypeId && this.model.barcode);
	}
}

export default ItemCreateController;


// WEBPACK FOOTER //
// ./client/app/components/item/create/item.create.controller.js